var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.homeData)?_c('div',[_c('MainCategoryBox'),(_vm.homeData)?_c('Targets'):_vm._e(),_c('IndustrialPark'),_c('Partners')],1):_c('loader')}
var staticRenderFns = []

export { render, staticRenderFns }